import React, { useEffect, useState } from "react";
import Conexao from '../Config/conexao';
import axios from 'axios';
import moment from 'moment';
import Navbar from '../SGI/EPIS/NavBarSSMT';
import { CheckBox } from "@mui/icons-material";
import { Container, ContainerForm, TextFieldStyled } from "./styles";
import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';
import download from "downloadjs";
import { Modal, Button } from 'react-bootstrap';
import { Row, Col, Offcanvas } from 'react-bootstrap';
import { Link, Redirect } from 'react-router-dom';
export default function CheckListCaminhaoPrancha() {


  const [mesEAno, setMesEAno] = useState();
  const [equipamento, setEquipamento] = useState();

  const [listaDados, setListaDados] = useState([]);
  const [listaDados2, setListaDados2] = useState([]);
  const [listaDados3, setListaDados3] = useState([]);


  const [abrirDia1, setAbrirDia1] = useState(false);


  // itens

  //dia 1
  const [item, setItem] = useState();
  const [item1, setItem1] = useState();
  const [item2, setItem2] = useState();
  const [item3, setItem3] = useState();
  const [item4, setItem4] = useState();
  const [item5, setItem5] = useState();
  const [item6, setItem6] = useState();
  const [item7, setItem7] = useState();
  const [item8, setItem8] = useState();
  const [item9, setItem9] = useState();
  const [item10, setItem10] = useState();
  const [item11, setItem11] = useState();
  const [item12, setItem12] = useState();
  const [item13, setItem13] = useState();
  const [item14, setItem14] = useState();
  const [item15, setItem15] = useState();
  const [item16, setItem16] = useState();
  const [item17, setItem17] = useState();
  const [item18, setItem18] = useState();
  const [item19, setItem19] = useState();
  const [item20, setItem20] = useState();
  const [item21, setItem21] = useState();
  const [item22, setItem22] = useState();
  const [item23, setItem23] = useState();
  const [item24, setItem24] = useState();
  const [item25, setItem25] = useState();
  const [item26, setItem26] = useState();
  const [item27, setItem27] = useState();
  const [item28, setItem28] = useState();
  const [item29, setItem29] = useState();
  const [item30, setItem30] = useState();
  const [item31, setItem31] = useState();

  const [dataDoCheckList, setDataDoCheckList] = useState();



  const [observacao, setObservacao] = useState('')
  const [projeto, setProjeto] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [tag, setTag] = useState('');
  const [drivername, setDrivername] = useState('');
  const [actiontaken, setActiontaken] = useState('');
  const [day, setDay] = useState('');
  const [status, setStatus] = useState('');

  const [habilitar, setHabilitar] = useState(false)
  const [bnthabilitar, setBnthabilitar] = useState(false)
  const [setorLogado, setSetorLogado] = useState();


  const [acao1, setAcao1] = useState();
  const [statusAcao1, setStatusAcao1] = useState();

  const [acao2, setAcao2] = useState();
  const [statusAcao2, setStatusAcao2] = useState();

  const [acao3, setAcao3] = useState();
  const [statusAcao3, setStatusAcao3] = useState();


  const [acao4, setAcao4] = useState();
  const [statusAcao4, setStatusAcao4] = useState();


  const [acao5, setAcao5] = useState();
  const [statusAcao5, setStatusAcao5] = useState();

  const [acao6, setAcao6] = useState();
  const [statusAcao6, setStatusAcao6] = useState();


  const [acao7, setAcao7] = useState();
  const [statusAcao7, setStatusAcao7] = useState();

  const [acao8, setAcao8] = useState();
  const [statusAcao8, setStatusAcao8] = useState();


  const [acao9, setAcao9] = useState();
  const [statusAcao9, setStatusAcao9] = useState();

  const [acao10, setAcao10] = useState();
  const [statusAcao10, setStatusAcao10] = useState();

  const [acao11, setAcao11] = useState();
  const [statusAcao11, setStatusAcao11] = useState();

  const [acao12, setAcao12] = useState();
  const [statusAcao12, setStatusAcao12] = useState();

  const [acao13, setAcao13] = useState();
  const [statusAcao13, setStatusAcao13] = useState();


  const [acao14, setAcao14] = useState();
  const [statusAcao14, setStatusAcao14] = useState();


  const [acao15, setAcao15] = useState();
  const [statusAcao15, setStatusAcao15] = useState();

  const [acao16, setAcao16] = useState();
  const [statusAcao16, setStatusAcao16] = useState();


  const [acao17, setAcao17] = useState();
  const [statusAcao17, setStatusAcao17] = useState();

  const [acao18, setAcao18] = useState();
  const [statusAcao18, setStatusAcao18] = useState();


  const [acao19, setAcao19] = useState();
  const [statusAcao19, setStatusAcao19] = useState();

  const [acao20, setAcao20] = useState();
  const [statusAcao20, setStatusAcao20] = useState();


  const [acao21, setAcao21] = useState();
  const [statusAcao21, setStatusAcao21] = useState();

  const [acao22, setAcao22] = useState();
  const [statusAcao22, setStatusAcao22] = useState();

  const [acao23, setAcao23] = useState();
  const [statusAcao23, setStatusAcao23] = useState();


  const [acao24, setAcao24] = useState();
  const [statusAcao24, setStatusAcao24] = useState();


  const [acao25, setAcao25] = useState();
  const [statusAcao25, setStatusAcao25] = useState();

  const [acao26, setAcao26] = useState();
  const [statusAcao26, setStatusAcao26] = useState();


  const [acao27, setAcao27] = useState();
  const [statusAcao27, setStatusAcao27] = useState();

  const [acao28, setAcao28] = useState();
  const [statusAcao28, setStatusAcao28] = useState();


  const [acao29, setAcao29] = useState();
  const [statusAcao29, setStatusAcao29] = useState();

  const [acao30, setAcao30] = useState();
  const [statusAcao30, setStatusAcao30] = useState();

  const [acao31, setAcao31] = useState();
  const [statusAcao31, setStatusAcao31] = useState();


  const [prazo1, setPrazo1] = useState();
  const [prazo2, setPrazo2] = useState();
  const [prazo3, setPrazo3] = useState();
  const [prazo4, setPrazo4] = useState();
  const [prazo5, setPrazo5] = useState();
  const [prazo6, setPrazo6] = useState();
  const [prazo7, setPrazo7] = useState();
  const [prazo8, setPrazo8] = useState();
  const [prazo9, setPrazo9] = useState();
  const [prazo10, setPrazo10] = useState();
  const [prazo11, setPrazo11] = useState();
  const [prazo12, setPrazo12] = useState();
  const [prazo13, setPrazo13] = useState();
  const [prazo14, setPrazo14] = useState();
  const [prazo15, setPrazo15] = useState();
  const [prazo16, setPrazo16] = useState();
  const [prazo17, setPrazo17] = useState();
  const [prazo18, setPrazo18] = useState();
  const [prazo19, setPrazo19] = useState();
  const [prazo20, setPrazo20] = useState();
  const [prazo21, setPrazo21] = useState();
  const [prazo22, setPrazo22] = useState();
  const [prazo23, setPrazo23] = useState();
  const [prazo24, setPrazo24] = useState();
  const [prazo25, setPrazo25] = useState();
  const [prazo26, setPrazo26] = useState();
  const [prazo27, setPrazo27] = useState();
  const [prazo28, setPrazo28] = useState();
  const [prazo29, setPrazo29] = useState();
  const [prazo30, setPrazo30] = useState();
  const [prazo31, setPrazo31] = useState();
  const [showSidebar, setShowSidebar] = useState(false);
  const [liClicked, setLiClicked] = useState(false);
  const handleShowSidebar = (index) => {
    setShowSidebar(true);
    //setBackgroundImage(images[index]);

  }
  const handleCloseSidebar = () => {
    setShowSidebar(false);
    
  }
  function Confirmacao() { alert("Salvo com sucesso!") };

  async function add() {
    const obj = {
      projeto, day, tag, drivername, month, year, actiontaken, status, item, item1, item2, item3, item4, item5, item6, item7, item8, item9, item10, item11, item12,
      item13, item14, item15, item16, item17, item18, item19, item20, item21, item22, item23, item24, item25, item26, observacao, dataDoCheckList: moment(dataDoCheckList).format('DD-MM-YYYY')

    };

    if (projeto !== "" && tag !== "" && drivername !== "" && item1 !== "" && item2 !== "" && item3 !== "" &&
      item4 !== "" && item5 !== "" && item6 !== "" && item7 !== "" && item8 !== "" && item9 !== "" && item10 !== "" && item11 !== "" && item12 !== "" &&
      item13 !== "" && item14 !== "" && item15 !== "" && item16 !== "" && item17 !== "" && item18 !== "" && item19 !== "" && item20 !== "" && item21 !== "" &&
      item22 !== "" && item23 !== "" && item24 !== "" && item25 !== "" && item26 !== "" && dataDoCheckList !== "") {
      const res = await axios.post(Conexao.api + 'InserteCheckRampa.php', obj);
      if (res.data.success === true) {
        Confirmacao();
        if (item1 === "Não Conforme") { addAcao1(); }
        if (item2 === "Não Conforme") { addAcao2(); }
        if (item3 === "Não Conforme") { addAcao3(); }
        if (item4 === "Não Conforme") { addAcao4(); }
        if (item5 === "Não Conforme") { addAcao5(); }
        if (item6 === "Não Conforme") { addAcao6(); }
        if (item7 === "Não Conforme") { addAcao7(); }
        if (item8 === "Não Conforme") { addAcao8(); }
        if (item9 === "Não Conforme") { addAcao9(); }
        if (item10 === "Não Conforme") { addAcao10(); }
        if (item11 === "Não Conforme") { addAcao11(); }
        if (item12 === "Não Conforme") { addAcao12(); }
        if (item13 === "Não Conforme") { addAcao13(); }
        if (item14 === "Não Conforme") { addAcao14(); }
        if (item15 === "Não Conforme") { addAcao15(); }
        if (item16 === "Não Conforme") { addAcao16(); }
        if (item17 === "Não Conforme") { addAcao17(); }
        if (item18 === "Não Conforme") { addAcao18(); }
        if (item19 === "Não Conforme") { addAcao19(); }
        if (item20 === "Não Conforme") { addAcao20(); }
        if (item21 === "Não Conforme") { addAcao21(); }
        if (item22 === "Não Conforme") { addAcao22(); }
        if (item23 === "Não Conforme") { addAcao23(); }
        if (item24 === "Não Conforme") { addAcao24(); }
        if (item25 === "Não Conforme") { addAcao25(); }
        if (item26 === "Não Conforme") { addAcao26(); }

        setBnthabilitar(true)

        Limpar()
      } else {
        // Tratar outro caso, se necessário
      }
    } else {
      msg();
    }
  }


  function msg() {
    alert("Por favor, preencha todos os campos obrigatórios.");
  }



  useEffect(() => { setHabilitar(true) && setBnthabilitar(true) }, [])

  function LimparX() {

    setDay('')
    setMonth('')
    setYear('')
    setItem1('')
    setDrivername('')
    setActiontaken('')
    setStatus('')
    setTag('')
    setItem('')
    setItem1('')
    setItem2('')
    setItem3('')
    setItem4('')
    setItem5('')
    setItem6('')
    setItem7('')
    setItem8('')
    setItem9('')
    setItem10('')
    setItem11('')
    setItem12('')
    setItem13('')
    setItem14('')
    setItem15('')
    setItem16('')
    setItem17('')
    setItem18('')
    setItem19('')
    setItem20('')
    setItem21('')
    setItem22('')
    setItem23('')
    setItem24('')
    setItem25('')
    setItem26('')
    setItem27('')
    setItem28('')
    setItem29('')
    setItem30('')
    setItem31('')
    setObservacao('')

    setAcao1('')
    setAcao2('')
    setAcao3('')
    setAcao4('')
    setAcao5('')
    setAcao6('')
    setAcao7('')
    setAcao8('')
    setAcao9('')
    setAcao10('')
    setAcao11('')
    setAcao12('')
    setAcao13('')
    setAcao14('')
    setAcao15('')
    setAcao16('')
    setAcao17('')
    setAcao18('')
    setAcao19('')
    setAcao20('')
    setAcao21('')
    setAcao22('')
    setAcao23('')
    setAcao24('')
    setAcao25('')
    setAcao26('')




    setPrazo1('')
    setPrazo2('')
    setPrazo3('')
    setPrazo4('')
    setPrazo5('')
    setPrazo6('')
    setPrazo7('')
    setPrazo8('')
    setPrazo9('')
    setPrazo10('')
    setPrazo11('')
    setPrazo12('')
    setPrazo13('')
    setPrazo14('')
    setPrazo15('')
    setPrazo16('')
    setPrazo17('')
    setPrazo18('')
    setPrazo19('')
    setPrazo20('')
    setPrazo21('')
    setPrazo22('')
    setPrazo23('')
    setPrazo24('')
    setPrazo25('')
    setPrazo26('')


    setMesEAno('');
    setEquipamento('');
  };





  //InserteCheckRampa



  function Limpar() {

    setMesEAno('');
    setEquipamento('');

  };

  function Limpar2() {

    // setMesEAno('');
    setEquipamento('');

  };



  async function getDados() {
    const res = await axios.get(Conexao.api + 'ListaCadastroProjetoWEB.php?projeto=' + projeto);

    if (res.data.success === false) {
    } else {
      setListaDados(res.data.result);
    }
  };

  async function getDados2() {
    const res = await axios.get(Conexao.api + 'ListaCadatroProjetosWEB2.php?projeto=' + projeto + '&mesEAno=' + mesEAno);

    if (res.data.success === false) {
    } else {
      setListaDados2(res.data.result);
    }
  };

  async function getDados3() {
    const res = await axios.get(Conexao.api + 'ListaCadastroProjetoWEB3.php');

    if (res.data.success === false) {
    } else {
      // setListaDados3(res.data.result);

      const projetosUnicos = [...new Set(res.data.result.map((dados3) => dados3.projeto))];
      setListaDados3(projetosUnicos);
    }
  };

  useEffect(() => { getDados() }, [projeto])

  useEffect(() => { getDados2() }, [mesEAno])

  useEffect(() => { getDados3() }, [projeto])



  function AbrirDia1() {
    setAbrirDia1(!abrirDia1);


  };

  async function BuscarCheckPrancha() {

    const res = await axios.get(Conexao.api + 'BuscarCheckPrancha.php?projeto=' + projeto + '&dataCheckList=' + moment(dataDoCheckList).format('DD-MM-YYYY'));
    console.log('retornoListar_Data', res.data.result[0])


    console.log('retornoListar_Data', res.data.result[0])

    if (res.data.success === true) {


      setItem1(res.data.result[0].tag)
      setDrivername(res.data.result[0].drivername)
      setActiontaken(res.data.result[0].actiontaken)
      setStatus(res.data.result[0].status)
      setTag(res.data.result[0].tag)
      setItem(res.data.result[0].item)
      setItem1(res.data.result[0].item1)
      setItem2(res.data.result[0].item2)
      setItem3(res.data.result[0].item3)
      setItem4(res.data.result[0].item4)
      setItem5(res.data.result[0].item5)
      setItem6(res.data.result[0].item6)
      setItem7(res.data.result[0].item7)
      setItem8(res.data.result[0].item8)
      setItem9(res.data.result[0].item9)
      setItem10(res.data.result[0].item10)
      setItem11(res.data.result[0].item11)
      setItem12(res.data.result[0].item12)
      setItem13(res.data.result[0].item13)
      setItem14(res.data.result[0].item14)
      setItem15(res.data.result[0].item15)
      setItem16(res.data.result[0].item16)
      setItem17(res.data.result[0].item17)
      setItem18(res.data.result[0].item18)
      setItem19(res.data.result[0].item19)
      setItem20(res.data.result[0].item20)
      setItem21(res.data.result[0].item21)
      setItem22(res.data.result[0].item22)
      setItem23(res.data.result[0].item23)
      setItem24(res.data.result[0].item24)
      setItem25(res.data.result[0].item25)
      setItem26(res.data.result[0].item26)

      setObservacao(res.data.result[0].observacao)






      setHabilitar(true)
      setBnthabilitar(true)
      //VariavelGlobal.ButtonEnable = false
      //getNivel()

      getAcoes1();
      getAcoes2();
      getAcoes3();
      getAcoes4();
      getAcoes5();
      getAcoes6();
      getAcoes7();
      getAcoes8();
      getAcoes9();
      getAcoes10();
      getAcoes11();
      getAcoes12();
      getAcoes13();
      getAcoes14();
      getAcoes15();
      getAcoes16();
      getAcoes17();
      getAcoes18();
      getAcoes19();
      getAcoes20();
      getAcoes21();
      getAcoes22();
      getAcoes23();
      getAcoes24();
      getAcoes25();
      getAcoes26();

    } else {

      setHabilitar(false)
      setBnthabilitar(false)

      alert('CHECK-LIST NÃO REALIZADO')
    }





  };










  const dataCheck = `${day}/ ${month}/ ${year}`;





  async function GerarPDF() {

    const pdfDoc = await PDFDocument.create()
    const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman)
    const arialFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
    const arialBoldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

    let page = pdfDoc.addPage()
    const { width, height } = page.getSize()
    const fontSize = 30


    // CABEÇALHO


    // LOGO GEOCONTROLE
    const imageUrl = 'data:image/png;base64,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';
    const imageBytes = await fetch(imageUrl).then(response => response.arrayBuffer());



    // Inserir a imagem na posição desejada
    const image = await pdfDoc.embedPng(imageBytes);
    const imageDims = image.scale(0.2); // Ajuste o fator de escala conforme necessário

    const xPosition = 27; // Ajuste a posição X da imagem
    const yPosition = 795; // Ajuste a posição Y da imagem


    const imageUrl3 = 'data:image/png;base64,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';
    const imageBytes3 = await fetch(imageUrl3).then(response => response.arrayBuffer());

    const image3 = await pdfDoc.embedPng(imageBytes3);
    const imageDims3 = image3.scale(0.2);


    const imageUrl4 = 'data:image/png;base64,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';
    const imageBytes4 = await fetch(imageUrl4).then(response => response.arrayBuffer());
    const image4 = await pdfDoc.embedPng(imageBytes4);


    const imageUrl5 = 'data:image/png;base64,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';
    const imageBytes5 = await fetch(imageUrl5).then(response => response.arrayBuffer());
    const image5 = await pdfDoc.embedPng(imageBytes5);





    page.drawImage(image, {
      x: xPosition,
      y: yPosition,
      width: imageDims.width,
      height: imageDims.height,
    });



    const imageUrl2 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAArMAAABACAIAAACGHGjSAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAhdEVYdENyZWF0aW9uIFRpbWUAMjAyMzowODozMSAxMzoxMDo0Ob1mDjYAAAEtSURBVHhe7d3BCQJBEEXBXVMxHg3WjcdYWpCR50XwKlZd5ofw6MvsM7MBADyd1gsAoAwAgHfKAACIMgAAogwAgCgDACDKAACIMgAAogwAgCgDACDKAACIMgAA8tWPSufbZS0A4Gfdr8dan7kZAABRBgBAlAEAEGUAAEQZAABRBgBAlAEAEGUAAEQZAABRBgBAlAEAEGUAAEQZAABRBgBAlAEAEGUAAEQZAABRBgBAlAEAEGUAAEQZAABRBgBAlAEAEGUAAEQZAABRBgBAlAEAEGUAAEQZAABRBgBAlAEAEGUAAEQZAABRBgBAlAEAkH1m1gQA/p6bAQAQZQAARBkAAFEGAECUAQAQZQAARBkAAFEGAECUAQAQZQAARBkAAFEGAECUAQAQZQAAvGzbA0nODHURHqEnAAAAAElFTkSuQmCC';
    const imageBytes2 = await fetch(imageUrl2).then(response => response.arrayBuffer());

    // Inserir a imagem na posição desejada
    const image2 = await pdfDoc.embedPng(imageBytes2);
    const imageDims2 = image2.scale(0.5); // Ajuste o fator de escala conforme necessário

    const xPosition2 = 369; // Ajuste a posição X da imagem
    const yPosition2 = 792; // Ajuste a posição Y da imagem

    page.drawImage(image2, {
      x: xPosition2,
      y: yPosition2,
      width: 200,
      height: 35,
    });

    page.drawText('PROJETO:     ' + projeto, {
      x: 435,
      y: 807,
      size: 12, // Tamanho da fonte
      font: arialFont,
      color: rgb(1, 1, 1), // Cor do texto (branco)
    });






    page.drawRectangle({
      x: 30,
      y: 765,
      width: 535,
      height: 30,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('Relatório:', {
      x: 32,
      y: 784,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawText('CHECKLIST CAMINHÃO PRANCHA', {
      x: 200,
      y: 774,
      size: 12, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });



    /*     //CODIGO
        page.drawRectangle({
          x: 455,
          y: 765,
          width: 110,
          height: 30,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(1, 1, 1),
        });
    
        page.drawText('', {
          x: 480,
          y: 775,
          size: 9, // Tamanho da fonte
          font: arialFont,
          color: rgb(0, 0, 0), // Cor do texto (branco)
        }); */


    //Condutor
    page.drawRectangle({
      x: 30,
      y: 735,
      width: 315,
      height: 30,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    page.drawText('Nome do condutor:', {
      x: 32,
      y: 754,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });
    if (drivername) {
      const textB = 30 + (315 / 2) - (drivername.length * 2.3);
      page.drawText(drivername || "", {
        x: textB,
        y: 742,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

    }



    //TAG
    page.drawRectangle({
      x: 345,
      y: 735,
      width: 110,
      height: 30,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    page.drawText('Placa/TAG:', {
      x: 347,
      y: 754,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });
    if (tag) {
      const textC = 345 + (110 / 2) - (tag.length * 2.3);
      page.drawText(tag || "", {
        x: textC,
        y: 742,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }


    //DATA
    page.drawRectangle({
      x: 455,
      y: 735,
      width: 110,
      height: 30,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('Data:', {
      x: 457,
      y: 754,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawText(moment(dataDoCheckList).format('DD/MM/YYYY') || "", {
      x: 487,
      y: 742,
      size: 9, // Tamanho da fonte
      font: arialFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawRectangle({
      x: 30,
      y: 705,
      width: 535,
      height: 30,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });


    /* 
        //TAG
        page.drawRectangle({
          x: 30,
          y: 735,
          width: 425,
          height: 30,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(1, 1, 1),
        });
        page.drawText('Placa/TAG:', {
          x: 32,
          y: 754,
          size: 9, // Tamanho da fonte
          font: arialBoldFont,
          color: rgb(0, 0, 0), // Cor do texto (branco)
        });
    
        page.drawText(tag, {
          x: 110,
          y: 742,
          size: 9, // Tamanho da fonte
          font: arialFont,
          color: rgb(0, 0, 0), // Cor do texto (branco)
        });
    
    
        //Espaço vazio encima da data
    
        page.drawRectangle({
          x: 455,
          y: 735,
          width: 110,
          height: 30,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(1, 1, 1),
        });
    
        page.drawText('', {
          x: 457,
          y: 754,
          size: 9, // Tamanho da fonte
          font: arialBoldFont,
          color: rgb(0, 0, 0), // Cor do texto (branco)
        });
    
        page.drawText('', {
          x: 487,
          y: 742,
          size: 9, // Tamanho da fonte
          font: arialFont,
          color: rgb(0, 0, 0), // Cor do texto (branco)
        });
    
    
    
        //Condutor
        page.drawRectangle({
          x: 30,
          y: 705,
          width: 425,
          height: 30,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(1, 1, 1),
        });
        page.drawText('Nome do condutor:', {
          x: 32,
          y: 724,
          size: 9, // Tamanho da fonte
          font: arialBoldFont,
          color: rgb(0, 0, 0), // Cor do texto (branco)
        });
        page.drawText(drivername, {
          x: 110,
          y: 712,
          size: 9, // Tamanho da fonte
          font: arialFont,
          color: rgb(0, 0, 0), // Cor do texto (branco)
        });
    
    
        //DATA
    
        page.drawRectangle({
          x: 455,
          y: 705,
          width: 110,
          height: 30,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(1, 1, 1),
        });
    
        page.drawText('Data:', {
          x: 457,
          y: 724,
          size: 9, // Tamanho da fonte
          font: arialBoldFont,
          color: rgb(0, 0, 0), // Cor do texto (branco)
        });
    
        page.drawText(dataCheck || "", {
          x: 487,
          y: 712,
          size: 9, // Tamanho da fonte
          font: arialFont,
          color: rgb(0, 0, 0), // Cor do texto (branco)
        }); */



    /* 
        //QUAL AÇÃO TOMADA
        page.drawRectangle({
          x: 30,
          y: 655,
          width: 535,
          height: 50,
          borderColor: rgb(0, 0, 0), // Cor da borda (preto)
          borderWidth: 1, // Largura da borda
          color: rgb(1, 1, 1),
        });
        page.drawText('Qual ação tomada?:', {
          x: 32,
          y: 694,
          size: 9, // Tamanho da fonte
          font: arialBoldFont,
          color: rgb(0, 0, 0), // Cor do texto (branco)
        });
    
        page.drawText(actiontaken, {
          x: 110,
          y: 682,
          size: 9, // Tamanho da fonte
          font: arialFont,
          color: rgb(0, 0, 0), // Cor do texto (branco)
        });
     */


    let pageCount = 1;

    page.drawText(`Página ${pageCount} `, {
      x: 505, // Ajuste as coordenadas conforme necessário
      y: 5,  // Ajuste as coordenadas conforme necessário
      size: 9,
      font: arialFont,
      color: rgb(0, 0, 0),
    });


    //777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777



    // CORPO DO ENSAIO



    page.drawRectangle({
      x: 30,
      y: 670,
      width: 535,
      height: 20,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });


    page.drawText('Formulário', {
      x: 255,
      y: 675,
      size: 10, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });



    let y = 630;


    //1
    page.drawRectangle({
      x: 30,
      y: y,
      width: 435,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('1. Renavan, DUT, Seguro Obrigatório estão na validade?', {
      x: 35,
      y: y + 16,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });


    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    if (item1) {
      const textX = 465 + (100 / 2) - (item1.length * 2.3);
      page.drawText(item1 || "", {
        x: textX,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item1 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao1 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo1).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }





    //2
    page.drawRectangle({
      x: 30,
      y: y,
      width: 435,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('2. Extintor ABC na validade e carregado?', {
      x: 35,
      y: y + 16,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });



    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item2) {
      const textX2 = 465 + (100 / 2) - (item2.length * 2.3);
      page.drawText(item2 || "", {
        x: textX2,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item2 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao2 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo2).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }



    //3
    page.drawRectangle({
      x: 30,
      y: y,
      width: 435,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('3. Luz giroscópica, antena com bandeirola e iluminação na ponta para veículo que acessa', {
      x: 35,
      y: y + 23,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawText(' área de mineração? ', {
      x: 48,
      y: y + 9,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });


    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item3) {
      const textX3 = 465 + (100 / 2) - (item3.length * 2.3);
      page.drawText(item3 || "", {
        x: textX3,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item3 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao3 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo3).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }


    //4
    page.drawRectangle({
      x: 30,
      y: y,
      width: 435,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('4. Sistema de registro de velocidade ou Tacógrafo estão funcionando?', {
      x: 35,
      y: y + 16,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item4) {
      const textX4 = 465 + (100 / 2) - (item4.length * 2.3);
      page.drawText(item4 || "", {
        x: textX4,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item4 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao4 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo4).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }



    //5
    page.drawRectangle({
      x: 30,
      y: y,
      width: 435,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('5. Faróis, lanternas, luz (de ré, de freio, do painel, da placa, de alerta) e buzina em perfeito', {
      x: 35,
      y: y + 23,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawText(' funcionamento?', {
      x: 48,
      y: y + 9,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });


    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item5) {
      const textX5 = 465 + (100 / 2) - (item5.length * 2.3);
      page.drawText(item5 || "", {
        x: textX5,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item5 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao5 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo5).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }



    //6
    page.drawRectangle({
      x: 30,
      y: y,
      width: 435,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('6. Freio de estacionamento está funcionando?', {
      x: 35,
      y: y + 16,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });


    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item6) {
      const textX6 = 465 + (100 / 2) - (item6.length * 2.3);
      page.drawText(item6 || "", {
        x: textX6,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item6 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao6 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo6).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }




    //7
    page.drawRectangle({
      x: 30,
      y: y,
      width: 435,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('7. Sinalização sonora de marcha-à-ré está funcionando?', {
      x: 35,
      y: y + 16,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });


    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item7) {
      const textX7 = 465 + (100 / 2) - (item7.length * 2.3);
      page.drawText(item7 || "", {
        x: textX7,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item7 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao7 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo7).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }


    if (y < 70) {
      page = pdfDoc.addPage([595, 842]);
      y = 770;
      pageCount++;
      page.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });
    }

    //8
    page.drawRectangle({
      x: 30,
      y: y,
      width: 435,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('8. Limpador de pára-brisa e sistema de injeção de água funcionando?', {
      x: 35,
      y: y + 16,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item8) {
      const textX8 = 465 + (100 / 2) - (item8.length * 2.3);
      page.drawText(item8 || "", {
        x: textX8,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item8 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao8 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo8).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }


    if (y < 70) {
      page = pdfDoc.addPage([595, 842]);
      y = 770;
      pageCount++;
      page.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });
    }

    //9
    page.drawRectangle({
      x: 30,
      y: y,
      width: 435,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('9. O reservatório do limpador de para brisas está abastecido com água limpa?', {
      x: 35,
      y: y + 16,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item9) {
      const textX9 = 465 + (100 / 2) - (item9.length * 2.3);
      page.drawText(item9 || "", {
        x: textX9,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item9 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao9 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo9).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }

    if (y < 70) {
      page = pdfDoc.addPage([595, 842]);
      y = 770;
      pageCount++;
      page.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });
    }

    //10
    page.drawRectangle({
      x: 30,
      y: y,
      width: 435,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('10. Rodas e pneus (inclusive estepe) em  condição de uso? Possui macaco, chave de roda', {
      x: 35,
      y: y + 23,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });
    page.drawText(' e triângulo/cones de sinalização?', {
      x: 48,
      y: y + 9,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item10) {
      const textX10 = 465 + (100 / 2) - (item10.length * 2.3);
      page.drawText(item10 || "", {
        x: textX10,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item10 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao10 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo10).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }

    if (y < 70) {
      page = pdfDoc.addPage([595, 842]);
      y = 770;
      pageCount++;
      page.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });
    }

    //11
    page.drawRectangle({
      x: 30,
      y: y,
      width: 435,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    //11.Os cintos de segurança estão em perfeitas condições de uso e funcionamento?
    page.drawText('11. Os cintos de segurança estão em perfeitas condições de uso e funcionamento,', {
      x: 35,
      y: y + 23,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });
    page.drawText('sem dispositivos que travem, afrouxem ou modifiquem seu funcionamento?', {
      x: 50,
      y: y + 9,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item11) {
      const textX11 = 465 + (100 / 2) - (item11.length * 2.3);
      page.drawText(item11 || "", {
        x: textX11,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item11 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao11 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo11).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }
    if (y < 70) {
      page = pdfDoc.addPage([595, 842]);
      y = 770;
      pageCount++;
      page.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });
    }


    //12
    page.drawRectangle({
      x: 30,
      y: y,
      width: 465,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('12. Possui no mínimo dois calços de segurança, que garantam imobilização ', {
      x: 35,
      y: y + 23,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });
    page.drawText('quando estacionado?', {
      x: 50,
      y: y + 9,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item12) {
      const textX12 = 465 + (100 / 2) - (item12.length * 2.3);
      page.drawText(item12 || "", {
        x: textX12,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item12 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao12 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo12).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }
    if (y < 70) {
      page = pdfDoc.addPage([595, 842]);
      y = 770;
      pageCount++;
      page.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });
    }


    //13
    page.drawRectangle({
      x: 30,
      y: y,
      width: 465,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    //13.Veículo possui combustível suficiente para o deslocamento pretendido?'
    page.drawText('13. Possui combustível suficiente para o deslocamento pretendido?', {
      x: 35,
      y: y + 16,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item13) {
      const textX13 = 465 + (100 / 2) - (item13.length * 2.3);
      page.drawText(item13 || "", {
        x: textX13,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item13 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao13 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo13).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }
    if (y < 70) {
      page = pdfDoc.addPage([595, 842]);
      y = 770;
      pageCount++;
      page.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });
    }

    //14
    page.drawRectangle({
      x: 30,
      y: y,
      width: 465,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    //14. Objetos que podem causar lesões em caso de colisão (mochilas,bolsas, laptops, etc)\n estão acondicionados ou afixados com cinto de segurança?
    page.drawText('14. Objetos que podem causar lesões em caso de colisão (mochilas,bolsas, laptops, etc)', {
      x: 35,
      y: y + 23,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawText('estão acondicionados no porta malas ou afixados com cinto de segurança?', {
      x: 50,
      y: y + 9,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item14) {
      const textX14 = 465 + (100 / 2) - (item14.length * 2.3);
      page.drawText(item14 || "", {
        x: textX14,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item14 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao14 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo14).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }
    if (y < 70) {
      page = pdfDoc.addPage([595, 842]);
      y = 770;
      pageCount++;
      page.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });
    }

    //15
    page.drawRectangle({
      x: 30,
      y: y,
      width: 465,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    //15.A carga está devidamente acondicionada e respeitando a capacidade do veículo \ne dimensões da carroceria?
    page.drawText('15. A carga está devidamente acondicionada e respeitando a capacidade do veículo ', {
      x: 35,
      y: y + 23,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });
    page.drawText(' e dimensões da carroceria?', {
      x: 48,
      y: y + 9,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item15) {
      const textX15 = 465 + (100 / 2) - (item15.length * 2.3);
      page.drawText(item15 || "", {
        x: textX15,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item15 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao15 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo15).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }
    if (y < 70) {
      page = pdfDoc.addPage([595, 842]);
      y = 770;
      pageCount++;
      page.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });
    }

    //16
    page.drawRectangle({
      x: 30,
      y: y,
      width: 465,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('16. A limpeza e higiene interna do veículo estão adequadas?', {
      x: 35,
      y: y + 16,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item16) {
      const textX16 = 465 + (100 / 2) - (item16.length * 2.3);
      page.drawText(item16 || "", {
        x: textX16,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item16 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao16 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo16).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }
    if (y < 70) {
      page = pdfDoc.addPage([595, 842]);
      y = 770;
      pageCount++;
      page.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });
    }

    //17
    page.drawRectangle({
      x: 30,
      y: y,
      width: 465,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('17. Para brisas, faróis, lanternas e placas estão limpos?', {
      x: 35,
      y: y + 16,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item17) {
      const textX17 = 465 + (100 / 2) - (item17.length * 2.3);
      page.drawText(item17 || "", {
        x: textX17,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item17 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao17 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo17).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }
    if (y < 70) {
      page = pdfDoc.addPage([595, 842]);
      y = 770;
      pageCount++;
      page.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });
    }

    //18
    page.drawRectangle({
      x: 30,
      y: y,
      width: 465,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText(' 18. Há vestígios de vazamentos de Óleos, Combustivel, Fluídos, Água? ', {
      x: 35,
      y: y + 16,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item18) {
      const textX18 = 465 + (100 / 2) - (item18.length * 2.3);
      page.drawText(item18 || "", {
        x: textX18,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item18 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao18 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo18).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }
    if (y < 70) {
      page = pdfDoc.addPage([595, 842]);
      y = 770;
      pageCount++;
      page.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });
    }

    //19
    page.drawRectangle({
      x: 30,
      y: y,
      width: 465,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('19. As correntes estão em boas condições de uso?', {
      x: 35,
      y: y + 16,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item19) {
      const textX19 = 465 + (100 / 2) - (item19.length * 2.3);
      page.drawText(item19 || "", {
        x: textX19,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item19 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao19 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo19).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }
    if (y < 70) {
      page = pdfDoc.addPage([595, 842]);
      y = 770;
      pageCount++;
      page.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });
    }

    //20
    page.drawRectangle({
      x: 30,
      y: y,
      width: 465,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('20. Os esticadores de corrente estão em boas condições de uso?', {
      x: 35,
      y: y + 16,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });
    /*     page.drawText('conjugado com o freio ou sistema similar de freio auxiliar (Top break, turbo break e outros)?', {
          x: 50,
          y: y+9,
          size: 9, // Tamanho da fonte
          font: arialBoldFont,
          color: rgb(0, 0, 0), // Cor do texto (branco)
        }); */

    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item20) {
      const textX20 = 465 + (100 / 2) - (item20.length * 2.3);
      page.drawText(item20 || "", {
        x: textX20,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item20 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao20 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo20).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }
    if (y < 70) {
      page = pdfDoc.addPage([595, 842]);
      y = 770;
      pageCount++;
      page.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });
    }

    //21
    page.drawRectangle({
      x: 30,
      y: y,
      width: 465,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('21. Cabo de aço em perfeitas condições para utilização?', {
      x: 35,
      y: y + 16,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });


    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item21) {
      const textX21 = 465 + (100 / 2) - (item21.length * 2.3);
      page.drawText(item21 || "", {
        x: textX21,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item21 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao21 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo21).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }
    if (y < 70) {
      page = pdfDoc.addPage([595, 842]);
      y = 770;
      pageCount++;
      page.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });
    }


    //22
    page.drawRectangle({
      x: 30,
      y: y,
      width: 465,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('22. Terminais trincados ou desgastados?', {
      x: 35,
      y: y + 16,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item22) {
      const textX22 = 465 + (100 / 2) - (item22.length * 2.3);
      page.drawText(item22 || "", {
        x: textX22,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item22 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao22 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo22).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }
    if (y < 70) {
      page = pdfDoc.addPage([595, 842]);
      y = 770;
      pageCount++;
      page.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });
    }

    //23
    page.drawRectangle({
      x: 30,
      y: y,
      width: 465,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('23. Presilhas desgastadas?', {
      x: 35,
      y: y + 16,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item23) {
      const textX23 = 465 + (100 / 2) - (item23.length * 2.3);
      page.drawText(item23 || "", {
        x: textX23,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item23 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao23 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo23).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }
    if (y < 70) {
      page = pdfDoc.addPage([595, 842]);
      y = 770;
      pageCount++;
      page.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });
    }


    //24
    page.drawRectangle({
      x: 30,
      y: y,
      width: 465,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('24. A cinta em condição de uso? Sem avarias, remendos?', {
      x: 35,
      y: y + 16,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });


    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item24) {
      const textX24 = 465 + (100 / 2) - (item24.length * 2.3);
      page.drawText(item24 || "", {
        x: textX24,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item24 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao24 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo24).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }
    if (y < 70) {
      page = pdfDoc.addPage([595, 842]);
      y = 770;
      pageCount++;
      page.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });
    }

    //25
    page.drawRectangle({
      x: 30,
      y: y,
      width: 465,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('25. A cinta está com o sistema de travamento (Catraca) em boas condições?', {
      x: 35,
      y: y + 16,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    /*   page.drawText('e está disponivel no véiculo/equipamento?', {
        x: 50,
        y: y+9,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      }); */

    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item25) {
      const textX25 = 465 + (100 / 2) - (item25.length * 2.3);
      page.drawText(item25 || "", {
        x: textX25,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item25 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao25 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo25).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }
    if (y < 70) {
      page = pdfDoc.addPage([595, 842]);
      y = 770;
      pageCount++;
      page.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });
    }


    //26
    page.drawRectangle({
      x: 30,
      y: y,
      width: 465,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('26. Gancho em perfeitas condições para utilização?', {
      x: 35,
      y: y + 16,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawRectangle({
      x: 465,
      y: y,
      width: 100,
      height: 40,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    if (item26) {
      const textX26 = 465 + (100 / 2) - (item26.length * 2.3);
      page.drawText(item26 || "", {
        x: textX26,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
    }
    y -= 40;

    if (item26 === "Não Conforme") {
      page.drawRectangle({
        x: 30,
        y: y,
        width: 535,
        height: 40,
        borderColor: rgb(0, 0, 0), // Cor da borda (preto)
        borderWidth: 1, // Largura da borda
        color: rgb(1, 1, 1),
      });

      page.drawText('Qual ação tomada?', {
        x: 35,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText(acao26 || "", {
        x: 140,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });

      page.drawText('Prazo:', {
        x: 455,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialBoldFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });
      page.drawText(moment(prazo26).format("DD/MM/YYYY") || "", {
        x: 495,
        y: y + 16,
        size: 9, // Tamanho da fonte
        font: arialFont,
        color: rgb(0, 0, 0), // Cor do texto (branco)
      });


      y -= 40;
    }
    if (y < 70) {
      page = pdfDoc.addPage([595, 842]);
      y = 770;
      pageCount++;
      page.drawText(`Página ${pageCount} `, {
        x: 505, // Ajuste as coordenadas conforme necessário
        y: 5,  // Ajuste as coordenadas conforme necessário
        size: 9,
        font: arialFont,
        color: rgb(0, 0, 0),
      });
    }





    //RODAPÉ
    page.drawRectangle({
      x: 30,
      y: 110,
      width: 535,
      height: 25,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });
    page.drawText('Observação:', {
      x: 32,
      y: 125,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });

    page.drawText(observacao || "", {
      x: 102,
      y: 115,
      size: 9, // Tamanho da fonte
      font: arialFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });


    page.drawRectangle({
      x: 30,
      y: 68,
      width: 268,
      height: 42,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('Operador:', {
      x: 32,
      y: 98,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });






    //88888888888888888888888888888

    page.drawRectangle({
      x: 298,
      y: 68,
      width: 267,
      height: 42,
      borderColor: rgb(0, 0, 0), // Cor da borda (preto)
      borderWidth: 1, // Largura da borda
      color: rgb(1, 1, 1),
    });

    page.drawText('Responsável:', {
      x: 300,
      y: 98,
      size: 9, // Tamanho da fonte
      font: arialBoldFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });





    //8888888888888888888888888888888888
    /*   page.drawRectangle({
    x: 386,
    y: 68,
    width: 179,
    height: 42,
    borderColor: rgb(0, 0, 0), // Cor da borda (preto)
    borderWidth: 1, // Largura da borda
    color: rgb(1,1,1), 
    }); */


    page.drawText('Este relatório de ensaio só pode ser copiado integralmente ou parcialmente com autorização da Geocontrole ', {
      x: 58,
      y: 57,
      size: 10, // Tamanho da fonte
      font: arialFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });


    page.drawImage(image2, {
      x: 20,
      y: 5,
      width: 556,
      height: 40,
    });
    page.drawText('www.geocontrole.com - e-mail: mail.br@geocontrole.com ', {
      x: 145,
      y: 24,
      size: 12, // Tamanho da fonte
      font: arialFont,
      color: rgb(1, 1, 1), // Cor do texto (branco)
    });

    page.drawText('Av.Canadá,Nº 159 - Jardim Canadá - Nova Lima - Minas Gerais - Brasil - CEP: 34007-654 Tel.: +55 31 3517-9011 ', {
      x: 45,
      y: 42,
      size: 10, // Tamanho da fonte
      font: arialFont,
      color: rgb(0, 0, 0), // Cor do texto (branco)
    });


    //999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999


    //RODAPÉ

    // page.drawRectangle({
    //   x: 30,
    //   y: 110,
    //   width: 535,
    //   height: 25,
    //   borderColor: rgb(0, 0, 0), // Cor da borda (preto)
    //   borderWidth: 1, // Largura da borda
    //   color: rgb(1,1,1), 
    //   });
    //   page.drawText('Observação:', {
    //   x: 32,
    //   y: 125,
    //   size: 9, // Tamanho da fonte
    //   font: arialBoldFont,
    //   color: rgb(0, 0, 0), // Cor do texto (branco)
    //   });

    //   page.drawText( observacao || "", {
    //   x: 102,
    //   y: 115,
    //   size: 9, // Tamanho da fonte
    //   font: arialFont,
    //   color: rgb(0, 0, 0), // Cor do texto (branco)
    //   });


    //   page.drawRectangle({
    //   x: 30,
    //   y: 68,
    //   width: 268,
    //   height: 42,
    //   borderColor: rgb(0, 0, 0), // Cor da borda (preto)
    //   borderWidth: 1, // Largura da borda
    //   color: rgb(1,1,1), 
    //   });

    //   page.drawText('Operador:', {
    //   x: 32,
    //   y: 98,
    //   size: 9, // Tamanho da fonte
    //   font: arialBoldFont,
    //   color: rgb(0, 0, 0), // Cor do texto (branco)
    //   });






    //   //88888888888888888888888888888

    //   page.drawRectangle({
    //   x: 298,
    //   y: 68,
    //   width: 267,
    //   height: 42,
    //   borderColor: rgb(0, 0, 0), // Cor da borda (preto)
    //   borderWidth: 1, // Largura da borda
    //   color: rgb(1,1,1), 
    //   });

    //   page.drawText('Responsável:', {
    //   x: 300,
    //   y: 98,
    //   size: 9, // Tamanho da fonte
    //   font: arialBoldFont,
    //   color: rgb(0, 0, 0), // Cor do texto (branco)
    //   });





    //   //8888888888888888888888888888888888
    //   /*   page.drawRectangle({
    //   x: 386,
    //   y: 68,
    //   width: 179,
    //   height: 42,
    //   borderColor: rgb(0, 0, 0), // Cor da borda (preto)
    //   borderWidth: 1, // Largura da borda
    //   color: rgb(1,1,1), 
    //   }); */


    //   page.drawText('Este relatório de ensaio só pode ser copiado integralmente ou parcialmente com autorização da Geocontrole ', {
    //   x: 58,
    //   y: 57,
    //   size: 10, // Tamanho da fonte
    //   font: arialFont,
    //   color: rgb(0, 0, 0), // Cor do texto (branco)
    //   });


    //   page.drawImage(image2, {
    //   x: 20,
    //   y: 5,
    //   width: 556,
    //   height: 40,
    //   });
    //   page.drawText('www.geocontrole.com - e-mail: mail.br@geocontrole.com ', {
    //   x: 145,
    //   y: 24,
    //   size: 12, // Tamanho da fonte
    //   font: arialFont,
    //   color: rgb(1, 1, 1), // Cor do texto (branco)
    //   });

    //   page.drawText('Av.Canadá,Nº 159 - Jardim Canadá - Nova Lima - Minas Gerais - Brasil - CEP: 34007-654 Tel.: +55 31 3517-9011 ', {
    //   x: 45,
    //   y: 42,
    //   size: 10, // Tamanho da fonte
    //   font: arialFont,
    //   color: rgb(0, 0, 0), // Cor do texto (branco)
    //   });


    //999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999

    page.drawText(`Página ${pageCount} `, {
      x: 505, // Ajuste as coordenadas conforme necessário
      y: 5,  // Ajuste as coordenadas conforme necessário
      size: 9,
      font: arialFont,
      color: rgb(0, 0, 0),
    });



    const pdfBytes = await pdfDoc.save()
    download(pdfBytes, "CheckListCaminhaoPrancha.pdf", "application/pdf");
    console.log(pdfBytes)
  }






  function splitTextIntoLines(text, maxLength) {
    const words = text.split(' ');
    const lines = [];
    let currentLine = '';

    for (const word of words) {
      if (currentLine.length + word.length <= maxLength) {
        currentLine += (currentLine.length > 0 ? ' ' : '') + word;
      } else {
        lines.push(currentLine);
        currentLine = word;
      }
    }

    if (currentLine.length > 0) {
      lines.push(currentLine);
    }

    return lines;
  }





  async function getAcoes1() {
    const checklist = "1"
    const numeroItem = '1'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);

    if (res.data.success === false) {
    } else {
      setAcao1(res.data.acao);
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo1(formattedDateISO);

      console.log('PRAZOOO  3: ' + formattedDate)
    }
  };

  async function getAcoes2() {
    const checklist = "1"
    const numeroItem = '2'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao2(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo2(formattedDateISO);
    }
  };
  async function getAcoes3() {
    const checklist = "1"
    const numeroItem = '3'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao3(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo3(formattedDateISO);
    }
  };
  async function getAcoes4() {
    const checklist = "1"
    const numeroItem = '4'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao4(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo4(formattedDateISO);
    }
  };

  async function getAcoes5() {
    const checklist = "1"
    const numeroItem = '5'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao5(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo5(formattedDateISO);
    }
  };

  async function getAcoes6() {
    const checklist = "1"
    const numeroItem = '6'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao6(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo6(formattedDateISO);
    }
  };

  async function getAcoes7() {
    const checklist = "1"
    const numeroItem = '7'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao7(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo7(formattedDateISO);
    }
  };

  async function getAcoes8() {
    const checklist = "1"
    const numeroItem = '8'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao8(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo8(formattedDateISO);
    }
  };

  async function getAcoes9() {
    const checklist = "1"
    const numeroItem = '9'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao9(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo9(formattedDateISO);
    }
  };

  async function getAcoes10() {
    const checklist = "1"
    const numeroItem = '10'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao10(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo10(formattedDateISO);
    }
  };

  async function getAcoes11() {
    const checklist = "1"
    const numeroItem = '11'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao11(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo11(formattedDateISO);
    }
  };

  async function getAcoes12() {
    const checklist = "1"
    const numeroItem = '12'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao12(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo12(formattedDateISO);
    }
  };

  async function getAcoes13() {
    const checklist = "1"
    const numeroItem = '13'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao13(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo13(formattedDateISO);
    }
  };

  async function getAcoes14() {
    const checklist = "1"
    const numeroItem = '14'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao14(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo14(formattedDateISO);
    }
  };

  async function getAcoes15() {
    const checklist = "1"
    const numeroItem = '15'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao15(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo15(formattedDateISO);
    }
  };

  async function getAcoes16() {
    const checklist = "1"
    const numeroItem = '16'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao16(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo16(formattedDateISO);
    }
  };

  async function getAcoes17() {
    const checklist = "1"
    const numeroItem = '17'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao17(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo17(formattedDateISO);
    }
  };

  async function getAcoes18() {
    const checklist = "1"
    const numeroItem = '18'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao18(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo18(formattedDateISO);
    }
  };

  async function getAcoes19() {
    const checklist = "1"
    const numeroItem = '19'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao19(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo19(formattedDateISO);
    }
  };

  async function getAcoes20() {
    const checklist = "1"
    const numeroItem = '20'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao20(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo20(formattedDateISO);
    }
  };

  async function getAcoes21() {
    const checklist = "1"
    const numeroItem = '21'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao21(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo21(formattedDateISO);
    }
  };

  async function getAcoes22() {
    const checklist = "1"
    const numeroItem = '22'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao22(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo22(formattedDateISO);
    }
  };

  async function getAcoes23() {
    const checklist = "1"
    const numeroItem = '23'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao23(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo23(formattedDateISO);
    }
  };

  async function getAcoes24() {
    const checklist = "1"
    const numeroItem = '24'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao24(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo24(formattedDateISO);
    }
  };

  async function getAcoes25() {
    const checklist = "1"
    const numeroItem = '25'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao25(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo25(formattedDateISO);
    }
  };

  async function getAcoes26() {
    const checklist = "1"
    const numeroItem = '26'
    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')
    const res = await axios.get(Conexao.api + 'BuscarAcoesCheckListWEB.php?checklist=' + checklist + '&numeroItem=' + numeroItem
      + '&projeto=' + projeto + '&dataCheckList=' + dataCheckList);
    if (res.data.success === false) {
    } else {
      setAcao26(res.data.acao)
      const formattedDate = res.data.prazo.split('-').join('/');
      const formattedDateISO = formattedDate.split('/').reverse().join('-');
      setPrazo26(formattedDateISO);
    }
  };



  async function addAcao1() {

    const checklist = "1"

    const numeroItem = '1'

    const acao = acao1

    const prazo = moment(prazo1).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }

  async function addAcao2() {

    const checklist = "1"

    const numeroItem = '2'

    const acao = acao2

    const prazo = moment(prazo2).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }

  async function addAcao3() {

    const checklist = "1"

    const numeroItem = '3'

    const acao = acao3

    const prazo = moment(prazo3).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }

  async function addAcao4() {

    const checklist = "1"

    const numeroItem = '4'

    const acao = acao4

    const prazo = moment(prazo4).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }

  async function addAcao5() {

    const checklist = "1"

    const numeroItem = '5'

    const acao = acao5

    const prazo = moment(prazo5).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }

  async function addAcao6() {

    const checklist = "1"

    const numeroItem = '6'

    const acao = acao6

    const prazo = moment(prazo6).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }

  async function addAcao7() {

    const checklist = "1"

    const numeroItem = '7'

    const acao = acao7

    const prazo = moment(prazo7).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }


  async function addAcao8() {

    const checklist = "1"

    const numeroItem = '8'

    const acao = acao8

    const prazo = moment(prazo8).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }


  async function addAcao9() {

    const checklist = "1"

    const numeroItem = '9'

    const acao = acao9

    const prazo = moment(prazo9).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }


  async function addAcao10() {

    const checklist = "1"

    const numeroItem = '10'

    const acao = acao10

    const prazo = moment(prazo10).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }

  async function addAcao11() {

    const checklist = "1"

    const numeroItem = '11'

    const acao = acao11

    const prazo = moment(prazo11).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }


  async function addAcao12() {

    const checklist = "1"

    const numeroItem = '12'

    const acao = acao12

    const prazo = moment(prazo12).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }

  async function addAcao13() {

    const checklist = "1"

    const numeroItem = '13'

    const acao = acao13

    const prazo = moment(prazo13).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }

  async function addAcao14() {

    const checklist = "1"

    const numeroItem = '14'

    const acao = acao14

    const prazo = moment(prazo14).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }

  async function addAcao15() {

    const checklist = "1"

    const numeroItem = '15'

    const acao = acao15

    const prazo = moment(prazo15).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }


  async function addAcao16() {

    const checklist = "1"

    const numeroItem = '16'

    const acao = acao16

    const prazo = moment(prazo16).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }

  async function addAcao17() {

    const checklist = "1"

    const numeroItem = '17'

    const acao = acao17

    const prazo = moment(prazo17).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }

  async function addAcao18() {

    const checklist = "1"

    const numeroItem = '18'

    const acao = acao18

    const prazo = moment(prazo18).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  } async function addAcao19() {

    const checklist = "1"

    const numeroItem = '19'

    const acao = acao19

    const prazo = moment(prazo19).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }

  async function addAcao20() {

    const checklist = "1"

    const numeroItem = '20'

    const acao = acao20

    const prazo = moment(prazo20).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }


  async function addAcao21() {

    const checklist = "1"

    const numeroItem = '21'

    const acao = acao21

    const prazo = moment(prazo21).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }


  async function addAcao22() {

    const checklist = "1"

    const numeroItem = '22'

    const acao = acao22

    const prazo = moment(prazo22).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }

  async function addAcao23() {

    const checklist = "1"

    const numeroItem = '23'

    const acao = acao23

    const prazo = moment(prazo23).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }

  async function addAcao24() {

    const checklist = "1"

    const numeroItem = '24'

    const acao = acao24

    const prazo = moment(prazo24).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }

  async function addAcao25() {

    const checklist = "1"

    const numeroItem = '25'

    const acao = acao25

    const prazo = moment(prazo25).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }


  async function addAcao26() {

    const checklist = "1"

    const numeroItem = '26'

    const acao = acao26

    const prazo = moment(prazo26).format('DD-MM-YYYY')

    const dataCheckList = moment(dataDoCheckList).format('DD-MM-YYYY')

    const obj = { acao, prazo, checklist, projeto, numeroItem, dataCheckList };

    const res = await axios.post(Conexao.api + 'InsertAcoesCheckWEB.php', obj);
    if (res.data.success === true) {
      // alert("ações salvas");
    } else {
      // Tratar outro caso, se necessário
    }

  }








  return <div className="home">

    <div className="banner" style={{ backgroundColor: '#DEDACF', width: 'auto', height: 'auto', minHeight: '1600px', minWidth: '1600px' }} >

      {/* Botao de Menu  */}
      <div className="sidebar-button">
        <Button variant="success" onClick={() => { handleShowSidebar(1) }} className="custom-button">
          <div className="icon-container">
            <i className="bi bi-list icon-circle"></i>
          </div>
        </Button>

      </div>
      {/* Bandeiras */}
      <div className="language-buttons">
        <Button variant="outline" className="rounded-circle">
          <img src="../Images/BandeiraBrasil.png" alt="Brasil" className="language-flag" />
        </Button>
        <Button variant="outline" className="rounded-circle">
          <img src="../Images/BandeiraPortugal.png" alt="Português" />
        </Button>
      </div>

      {/* Titulo */}
      <div className="sidebar-Text">
        <text style={{ color: '#187A40', fontWeight: 'bold', textShadow: 'none', fontFamily: 'Open Sans, sans-serif', marginLeft: '20%', }}>Check List de Inspeção Diária - Caminhão Prancha</text>
      </div>
      {/* Logica da pagina */}
      <Container>
        <ContainerForm>


          <body className="col lign-items-center text-center mt-2">
            <div className="  row d-flex justify-content-center  align-items-center p-1 mt-2" >
              <div class="col-1 ">
                <h6    >Projeto</h6>
              </div>
              <div class="col-2  ">
                <input list="ListProjeto" onChange={(e) => setProjeto(e.target.value) & LimparX()} value={projeto} placeholder='Selecione o projeto' class="borda form-control w-100 text-center colorInput"  ></input>
                <datalist id="ListProjeto">
                  {listaDados3.map((projeto, index) => (
                    <option key={index}>{projeto}</option>
                  ))}
                </datalist>
              </div>
            </div>


            {/*      <div className="  row d-flex justify-content-center  align-items-center p-1 mt-2" >
        <div class="col-1  ">
          <h6   >Dia:</h6>
        </div>
        <div className=" mt-2 col-2">
          <select onChange={(e) => setDay(e.target.value)} value={day} className=" form-select text-center">
            <option className="text-start" value={"-"}> - </option>
            <option className="text-start" value={"01"}> 01</option>
            <option className="text-start" value={"02"}> 02</option>
            <option className="text-start" value={"03"}> 03</option>
            <option className="text-start" value={"04"}> 04</option>
            <option className="text-start" value={"05"}> 05</option>
            <option className="text-start" value={"06"}> 06 </option>
            <option className="text-start" value={"07"}> 07</option>
            <option className="text-start" value={"08"}> 08</option>
            <option className="text-start" value={"09"}> 09</option>
            <option className="text-start" value={"10"}> 10</option>
            <option className="text-start" value={"11"}> 11</option>
            <option className="text-start" value={"12"}> 12</option>
            <option className="text-start" value={"13"}> 13</option>
            <option className="text-start" value={"14"}> 14</option>
            <option className="text-start" value={"15"}> 15</option>
            <option className="text-start" value={"16"}> 16 </option>
            <option className="text-start" value={"17"}> 17</option>
            <option className="text-start" value={"18"}> 18</option>
            <option className="text-start" value={"19"}> 19</option>
            <option className="text-start" value={"20"}> 20</option>
            <option className="text-start" value={"21"}> 21</option>
            <option className="text-start" value={"22"}> 22</option>
            <option className="text-start" value={"23"}> 23</option>
            <option className="text-start" value={"24"}> 24</option>
            <option className="text-start" value={"25"}> 25</option>
            <option className="text-start" value={"26"}> 26 </option>
            <option className="text-start" value={"27"}> 27</option>
            <option className="text-start" value={"28"}> 28</option>
            <option className="text-start" value={"29"}> 29</option>
            <option className="text-start" value={"30"}> 30</option>
            <option className="text-start" value={"31"}> 31</option>
          </select>
        </div>

      </div>




      <div className="  row d-flex justify-content-center  align-items-center p-1 mt-2" >
        <div class="col-1  ">
          <h6   >Mês:</h6>
        </div>
        <div className=" mt-2 col-2">
          <select onChange={(e) => setMonth(e.target.value)} value={month} className=" form-select text-center">
            <option className="text-start" value={"-"}> - </option>
            <option className="text-start" value={"01"}> 01</option>
            <option className="text-start" value={"02"}> 02</option>
            <option className="text-start" value={"03"}> 03</option>
            <option className="text-start" value={"04"}> 04</option>
            <option className="text-start" value={"05"}> 05</option>
            <option className="text-start" value={"06"}> 06 </option>
            <option className="text-start" value={"07"}> 07</option>
            <option className="text-start" value={"08"}> 08</option>
            <option className="text-start" value={"09"}> 09</option>
            <option className="text-start" value={"10"}> 10</option>
            <option className="text-start" value={"11"}> 11</option>
            <option className="text-start" value={"12"}> 12</option>
          </select>
        </div>

      </div>
      <div className="  row d-flex justify-content-center  align-items-center p-1 mt-2" >
        <div class="col-1  ">
          <h6   >Ano:</h6>
        </div>
        <div className=" mt-2 col-2">
          <select onChange={(e) => setYear(e.target.value)} value={year} className=" form-select text-center">
            <option className="text-start" value={"-"}> - </option>
            <option className="text-start" value={"2022"}> 2022</option>
            <option className="text-start" value={"2023"}> 2023</option>
            <option className="text-start" value={"2024"}> 2024</option>
            <option className="text-start" value={"2025"}> 2025</option>
            <option className="text-start" value={"2026"}> 2026</option>
            <option className="text-start" value={"2027"}> 2027</option>
            <option className="text-start" value={"2028"}> 2028</option>
            <option className="text-start" value={"2029"}> 2029</option>
            <option className="text-start" value={"2030"}> 2030</option>

          </select>
        </div> */}



            <div className="  row d-flex justify-content-center  align-items-center p-1 mt-2" >
              <div class="col-1  ">
                <h6 className="mt-1" >Data:</h6>
              </div>
              <div className=" mt-2 col-2">
                <input onChange={(e) => setDataDoCheckList(e.target.value) & LimparX()} value={dataDoCheckList} type="date" className="colorInput borda form-control text-center"></input>
              </div>
            </div>



            {/*  </div> */}

            <br />
            <br />

            <div className="  row d-flex justify-content-center  align-items-center p-1 mt-2" >

              <div class="col-4">
                <div className="btn btn-outline-success-center " type="submit"><button onClick={(e) => BuscarCheckPrancha(e)} class="btnlogin me-md-2" > Buscar</button>
                </div>
              </div>
            </div>


            <br />
            <br />

            <div className="  row d-flex justify-content-center  align-items-center p-1 mt-2" >

              <div class="col-1 ">
                <h6   >Placa/TAG:</h6>
              </div>
              <div class="col-2  ">
                <input list="ListTag" onChange={(e) => setTag(e.target.value)} value={tag} disabled={habilitar} placeholder='Numero da Placa/Tag' class="borda form-control w-100 text-center colorInput"  ></input>
                <datalist id="ListTag"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.tag} </option>))}</datalist>
              </div>
            </div>

          </body>


          <div className='titulolaboratorio container-fluid '>
            <h3 style={{ color: '#000' }} >Relação de Condutores x Dia :</h3>
          </div>



          <div className="  row d-flex justify-content-center  align-items-center p-1 mt-3" >
            <div class="col-1  "></div>
            <div class="col-auto ">
              <h6 style={{ color: '#000' }} >Nome do condutor :</h6>
            </div>
            <div class="col-3  ">
              <input placeholder='Nome do condutor' list="ListDrivername" onChange={(e) => setDrivername(e.target.value)} value={drivername} disabled={habilitar} class="borda form-control w-100 text-center colorInput"  ></input>
              <datalist id="ListDrivername"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.drivername} </option>))}</datalist>
            </div>
          </div>




          <div className="   container d-flex   justify-content-center  align-items-center p-2 mt-3" >

            <h5 style={{ color: '#000' }}>DADOS DE VERIFICAÇÃO DA INSPEÇÃO</h5>

          </div>




          <div className="  col-12 container d-flex  flex-column justify-content-center  align-items-center p-2 mt-2" >


            <div className=" container-fluid text-center borda row align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                1 - Renavan, DUT, Seguro Obrigatório estão na validade?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem1(e.target.value)} value={item1} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>

            {item1 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao1(e.target.value)} value={acao1} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo1(e.target.value)} value={prazo1} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
              
              <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>

              </div>
            </body>)
              : null}

            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                2 -  Extintor ABC na validade e carregado?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem2(e.target.value)} value={item2} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item2 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao2(e.target.value)} value={acao2} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo2(e.target.value)} value={prazo2} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
              
              <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}

            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                3 -  Luz giroscópica, antena com bandeirola e iluminação na ponta para  veículo que  acessa área de mineração?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem3(e.target.value)} value={item3} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item3 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao3(e.target.value)} value={acao3} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo3(e.target.value)} value={prazo3} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
             
              <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}


            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                4 - Sistema de registro de velocidade ou Tacógrafo estão funcionando?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem4(e.target.value)} value={item4} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item4 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao4(e.target.value)} value={acao4} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo4(e.target.value)} value={prazo4} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
              
              <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}

            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                5 - Faróis, lanternas, luz (de ré, de freio, do painel, da placa, de alerta) e buzina em perfeito funcionamento?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem5(e.target.value)} value={item5} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item5 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao5(e.target.value)} value={acao5} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo5(e.target.value)} value={prazo5} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
              
              <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}

            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                6 - Freio de estacionamento está funcionando?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem6(e.target.value)} value={item6} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item6 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao6(e.target.value)} value={acao6} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo6(e.target.value)} value={prazo6} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
              
              <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}

            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                7 - Sinalização sonora de marcha-à-ré está funcionando?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem7(e.target.value)} value={item7} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item7 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao7(e.target.value)} value={acao7} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo7(e.target.value)} value={prazo7} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
              
              <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}

            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                8 - Limpador de pára-brisa e sistema de injeção de água funcionando?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem8(e.target.value)} value={item8} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item8 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao8(e.target.value)} value={acao8} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo8(e.target.value)} value={prazo8} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
          <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}

            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                9 - O reservatório do limpador de para brisas está abastecido com água limpa?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem9(e.target.value)} value={item9} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item9 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao9(e.target.value)} value={acao9} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo9(e.target.value)} value={prazo9} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
          <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}

            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                10 - Rodas e pneus (inclusive estepe) em  condição de uso? Possui triângulo/cones de sinalização?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem10(e.target.value)} value={item10} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item10 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao10(e.target.value)} value={acao10} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo10(e.target.value)} value={prazo10} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
          <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}

            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                11 - Os cintos de segurança estão em perfeitas condições de uso e funcionamento?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem11(e.target.value)} value={item11} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>


            </div>


            {item11 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao11(e.target.value)} value={acao11} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo11(e.target.value)} value={prazo11} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
          <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}

            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                12 - Veículo possui calço de segurança?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem12(e.target.value)} value={item12} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item12 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao12(e.target.value)} value={acao12} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo12(e.target.value)} value={prazo12} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
          <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}

            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                13 - Veículo possui combustível suficiente para o deslocamento pretendido?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem13(e.target.value)} value={item13} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>



            {item13 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao13(e.target.value)} value={acao13} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo13(e.target.value)} value={prazo13} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
          <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}

            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                14 - Objetos que podem causar lesões em caso de colisão (mochilas,bolsas, laptops, etc) estão acondicionados ou afixados com cinto de segurança?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem14(e.target.value)} value={item14} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item14 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao14(e.target.value)} value={acao14} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo14(e.target.value)} value={prazo14} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
          <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}




            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                15 - A carga está devidamente acondicionada e respeitando a capacidade do veículo e dimensões da carroceria?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem15(e.target.value)} value={item15} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item15 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao15(e.target.value)} value={acao15} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo15(e.target.value)} value={prazo15} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
          <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}


            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                16 - A limpeza e higiene interna do veículo estão adequadas?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem16(e.target.value)} value={item16} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item16 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao16(e.target.value)} value={acao16} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo16(e.target.value)} value={prazo16} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
          <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}


            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                17 - Para brisas, faróis, lanternas e placas estão limpos?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem17(e.target.value)} value={item17} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item17 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao17(e.target.value)} value={acao17} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo17(e.target.value)} value={prazo17} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
          <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}


            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                18 - Há vestígios de vazamentos de Óleos, Combustivel,Fluídos,Água?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem18(e.target.value)} value={item18} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item18 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao18(e.target.value)} value={acao18} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo18(e.target.value)} value={prazo18} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
          <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}


            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                19 - As correntes estão em boas condições de uso?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem19(e.target.value)} value={item19} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item19 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao19(e.target.value)} value={acao19} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo19(e.target.value)} value={prazo19} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
          <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}


            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                20 - Os esticadores de corrente estão em boas condições de uso?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem20(e.target.value)} value={item20} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item20 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao20(e.target.value)} value={acao20} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo20(e.target.value)} value={prazo20} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
          <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}


            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                21 - Cabo de aço em perfeitas condições para utilização

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem21(e.target.value)} value={item21} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item21 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao21(e.target.value)} value={acao21} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo21(e.target.value)} value={prazo21} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
          <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}


            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                22 - Terminais trincados ou desgastados ?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem22(e.target.value)} value={item22} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item22 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao22(e.target.value)} value={acao22} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo22(e.target.value)} value={prazo22} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
          <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}


            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                23 - Presilhas desgastadas?

              </div>
              <div className=" mt-2  col-2">
                <select onChange={(e) => setItem23(e.target.value)} value={item23} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item23 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao23(e.target.value)} value={acao23} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo23(e.target.value)} value={prazo23} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
          <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}


            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start  " style={{ color: '#000' }}>
                24 - A cintas em condição de uso? Sem avarias, remendos?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem24(e.target.value)} value={item24} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item24 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao24(e.target.value)} value={acao24} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo24(e.target.value)} value={prazo24} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
          <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}


            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                25 - A cinta está com o sistema de travamento (Catraca) em boas condições?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem25(e.target.value)} value={item25} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item25 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao25(e.target.value)} value={acao25} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo25(e.target.value)} value={prazo25} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
          <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}


            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}
            <div className=" container-fluid text-center borda row mt-2 align-items-center">
              <div className=" col-10 text-start " style={{ color: '#000' }}>
                26 - Gancho em perfeitas condições para utilização?

              </div>
              <div className=" mt-2 col-2">
                <select onChange={(e) => setItem26(e.target.value)} value={item26} disabled={habilitar} className=" form-select text-center">
                  <option className="text-start" value={"-"}> Selecione</option>
                  <option className="text-start" value={"Conforme"}> Conforme</option>
                  <option className="text-start" value={"Não Conforme"}> Não Conforme</option>
                  <option className="text-start" value={"Não Aplicável"}> Não Aplicável</option>
                </select>
              </div>

            </div>


            {item26 === 'Não Conforme' ? (<body className="container-fluid text-center justify-content-center mt-2">
              <div> <h6> Plano de ação</h6> </div>
              <div className="container    mt-3">
                <div className="col d-flex align-items-center ">
                  <div className="col-3">
                    <h6 > Qual a ação tomada?</h6>
                  </div>
                  <div className="col-8">
                    <input list="actiontaken" onChange={(e) => setAcao26(e.target.value)} value={acao26} disabled={habilitar} placeholder='' class="ms-2  borda form-control w-100 text-center colorInput"  ></input>
                    <datalist id="actiontaken"> {listaDados2.map((dados2) => (<option key={dados2.id} > {dados2.actiontaken} </option>))}</datalist>
                  </div>
                </div>
                <div className="col d-flex container  justify-content-center mt-2">
                  <div className="col-4 d-flex align-items-center ">
                    <h6 className="ms-5"> Prazo:</h6>
                    <input onChange={(e) => setPrazo26(e.target.value)} value={prazo26} disabled={habilitar} type="date" className="ms-2 borda form-control"></input>
                  </div>
                  {/*           <div className="col-4 d-flex align-items-center text-center ">
          <button disabled={habilitar}   class="botaoadicionar ">Salvar</button>
          </div> */}
                </div>
              </div>
            </body>)
              : null}


            {/* 77777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777 */}



          </div>



          <body class="container text-center ">

            <div class="container text-center ">
              <div class="row d-flex align-items-end justify-content-center p-2">

                <div className="  col-10    ">
                  <h5 className="  label  " >Observação </h5>
                  <textarea cols={100} rows={6} className='form-control w-200 colorInput resize' disabled={habilitar} name='observacoes' id='observacoes' value={observacao} onChange={(e) => setObservacao(e.target.value)}  ></textarea>
                </div>


              </div>
            </div>

          </body>









          {/* <div class="row d-flex align-items-end justify-content-end p-1 mt-3 ">
            <div class="col-4">
                <button
                onClick={()=>add()}  class="botaoadicionar " disabled={habilitar} hidden={bnthabilitar}>Salvar</button>
                 <button  onClick={() =>GerarPDF()} className="btn btn-danger btn-cli" ><i className="far fa-file-pdf"></i> Gerar PDF </button>    
            </div>
        </div> */}

          <div class="container d-flex align-items-end justify-content-end p-3 ">
            <div class="col-6 d-flex me-5 ">
              <button onClick={() => GerarPDF()} className="btn btn-danger btn-cli" ><i className="far fa-file-pdf"></i> Gerar PDF </button>
              <button onClick={() => add()} class="botaoadicionar " disabled={habilitar} hidden={bnthabilitar}style={{ color: '#fff' }} >salvar</button>
            </div>
          </div>






        </ContainerForm>
      </Container>
      <Offcanvas show={showSidebar} onHide={handleCloseSidebar} className="first-sidebarNav">
        <div className="offcanvas-header">
          
         
          <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="offcanvas" onClick={() => { handleCloseSidebar(1) }} aria-label="Close"></button>
        </div>
        <Offcanvas.Body>
          <ul>
            <li className={`${liClicked ? 'li-slide-right' : ''}`} >
              <Link to="/app/SSMA" style={{ textDecoration: 'none' }}>
                <button className="btn btn-success mt-4 btn-block hover-effect" style={{ borderRadius: '100px', width: '70%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto', fontSize: '20px' }}>Menu</button></Link>
            </li>
            {/* <li className={liClicked1 ? 'li-slide-right' : ''} onClick={() => handleLiClickSobre(3)}>
              <Button variant="link" style={{ textDecoration: 'none', color: 'white',color: liClicked1 ? '#00221A' : 'white', fontSize: '1.5em' }}>Sobre o Geo+ <span className="icon-right move-right1">
                <i className="bi bi-chevron-right"style={{textDecoration: 'none',color: liClicked1 ? '#00221A' : 'white'}}></i>
              </span></Button>
            </li> */}
            {/* <li className={liClicked2 ? 'li-slide-right' : ''} >
              <Button variant="link" style={{ textDecoration: 'none', color: 'white', fontSize: '1.5em' }}>Suporte <span className="icon-right move-right2">
                <i className="bi bi-chevron-right"></i>
              </span></Button>
            </li> */}
            {/* <li className={liClicked3 ? 'li-slide-right' : ''} onClick={() => handleLiClickGeocontrole(4)}>
              <Button variant="link" style={{ textDecoration: 'none', color: 'white',color: liClicked3 ? '#00221A' : 'white', fontSize: '1.5em' }}>Geocontrole <span className="icon-right move-right3">
                <i className="bi bi-chevron-right"style={{textDecoration: 'none',color: liClicked3 ? '#00221A' : 'white'}}></i>
              </span></Button>
            </li> */}
          </ul>
        </Offcanvas.Body>
      </Offcanvas>



    </div>
  </div>

};